import { useEffect, useState } from "react";
import "../css/dashboard.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { roles } from "../firebase.collection";
import {
  documentId,
  onSnapshot,
  query,
  where,
  collection,
} from "firebase/firestore";
import { db } from "../firebase";
import TitleMedium5 from "../component/Titles/TitleMedium5";
import FormLineMedium5 from "../component/FormLineMedium5";
import TopTitleBannerV2 from "../component/TopTitleBannerV2";
import { Skeleton } from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import FlipNumbers from "react-flip-numbers";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function RolesContent() {
  const [allRoles, setAllRoles] = useState([]);
  const [userRole, setUserRole] = useState("");
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const { translate } = useContext(LanguageContext);

  const userIdState = currentUser ? currentUser.uid : "";

  useEffect(() => {
    const roleCollection = collection(db, "roles");
    const unsubscribe = onSnapshot(roleCollection, (querySnapshot) => {
      setAllRoles(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
      setIsLoading(false);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  const isSuperAdmin =
    userRole === "Super Admin" || userRole === "Clinical Director";

  return (
    <div className="right-container-settings">
      {isSuperAdmin ? (
        <div className="admin-panel">
          <TopTitleBannerV2 title={translate("RoleManagement")} />
          <div
            style={{
              width: "90%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 0",
              marginLeft: "40px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <StorageIcon style={{ marginRight: 8, color: "#a3a3a4" }} />
              <div style={{ fontWeight: 650, fontSize: 22, paddingRight: 5 }}>
                <FlipNumbers
                  height={30}
                  width={15}
                  color="#000000"
                  background="white"
                  play
                  perspective={1000}
                  numbers={(allRoles?.length || 0).toString()}
                />
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 500,
                  color: "#a3a3a4",
                  lineHeight: "14px",
                  paddingTop: 2,
                  paddingLeft: 5,
                }}
              >
                {`${translate("TotalRecord")}${allRoles.length > 1 ? "s" : ""}`}
              </div>
            </div>
          </div>

          <div className="profile-title-setting">
            <div className="grey-subtitle-2 ">
              {translate("SuperAdminSubtitle")}
            </div>
          </div>

          <TitleMedium5 />

          {isLoading
            ? Array.from({ length: 10 }).map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "90%",
                    margin: "0 0 8px 40px",
                    background: "white",
                    borderRadius: 5,
                    height: 60,
                    display: "flex",
                    alignItems: "center",
                    padding: "0 10px",
                    borderBottom: "1px solid lightgrey",
                  }}
                >
                  <Skeleton
                    variant="text"
                    width="28%"
                    height={28}
                    style={{ marginRight: 10 }}
                  />
                  <Skeleton
                    variant="text"
                    width="22%"
                    height={28}
                    style={{ marginRight: 10 }}
                  />
                  <Skeleton
                    variant="text"
                    width="18%"
                    height={28}
                    style={{ marginRight: 10 }}
                  />
                  <Skeleton
                    variant="text"
                    width="18%"
                    height={28}
                    style={{ marginRight: 10 }}
                  />
                  <Skeleton variant="rectangular" width={100} height={36} />
                </div>
              ))
            : allRoles.map((role) => (
                <FormLineMedium5
                  key={role.id}
                  userId={role.id}
                  userName={role.displayName}
                  userRole={role.role}
                  userPhone={role.phoneNumber}
                  userEmail={role.userEmail}
                />
              ))}
        </div>
      ) : (
        <div>
          <TopTitleBannerV2 title={translate("RoleManagement")} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --{translate("NoSuperAdminAccess")}--
          </p>
        </div>
      )}
    </div>
  );
}
